import find from 'lib/sequence/component/children/find'
import { checked } from 'lib/sequence/component/state/checked'

/**
 * Terms of use step action.
 *
 * Sets the step as completed if the ToS checkbox is checked.
 *
 * @param module the current module composition object
 */
export default (module: Gaia.AppModule.Spec) => component => async (...args) => {
  const stepState = component[G.STATE]
  const { termsOfUse } = find(component)

  stepState.completed = !!checked(termsOfUse)
  stepState.confirmed = stepState.completed

  return args
}
